import { getDataBase } from '../db';

export default class ParametrosGeneralesDAL {

    GetAlldt = async (DataBaseAlias) => {
        try {
            const db = await getDataBase();
            const tx = db.transaction('PARAMETROGENERALES', 'readonly');
            const store = tx.objectStore('PARAMETROGENERALES');
            const clientes = await store.getAll();
            await tx.done;
            return clientes;

        } catch (error) {

        }

    }


    async GetFechaCorteParaGene(){
        try {
            const db = await getDataBase();
            const tx = db.transaction('PARAMETROGENERALES', 'readonly');
            const store = tx.objectStore('PARAMETROGENERALES');
            const laData = await store.getAll();
            await tx.done;
            return laData;
        } catch (error) {
          console.error('Error en GetFechaCorteParaGene:', error);
          return [];
        }
    }

}